module.exports = __webpack_public_path__ + "img/pig.93848bc5.svg";